import { Divider } from "@mui/material";
import React from "react";

import {
  SafeArgonBox as ArgonBox,
  SafeArgonTypography as ArgonTypography,
} from "0.Mine/4.Argon/ArgonComponents";

import { FormData } from "../sharedTypes";

import FormFields from "./FormFields";

interface LeadInfoFormProps {
  formData: FormData;
  isMobile: boolean;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleSelectChange: (e: any) => void;
  handleDateChange: (date: Date | null) => void;
  handleSubmit: (e: React.FormEvent) => void;
}

const LeadInfoForm: React.FC<LeadInfoFormProps> = ({
  formData,
  isMobile,
  handleInputChange,
  handleSelectChange,
  handleDateChange,
  handleSubmit,
}) => {
  return (
    <form onSubmit={handleSubmit}>
      <ArgonBox mb={2}>
        <ArgonTypography variant="h6" fontWeight="medium">
          Informazioni
        </ArgonTypography>
        <Divider sx={{ my: 1.5 }} />
      </ArgonBox>

      <FormFields
        formData={formData}
        isMobile={isMobile}
        handleInputChange={handleInputChange}
        handleSelectChange={handleSelectChange}
        handleDateChange={handleDateChange}
      />
    </form>
  );
};

export default LeadInfoForm;
